var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { default as React, useEffect, useState } from 'react';
import { AlertBanner, AlertBannerTypes } from '../Components/AlertBanner';
import styles from './ClinicalDecisionSupport.module.css';
import { Button, ButtonMode, ButtonVariant } from '../Components/Button';
import { AlertType } from '../Contracts/ClinicalDecisionSupportDetails.Response';
import { singularisePluralise } from '../Shared/StringUtilities';
import { DeleteMedicationDialog } from '../MedicationSummary/DeleteMedicationDialog';
import { useError } from '../Components/ErrorBoundary';
import { useMedicationSettings } from '../Config/MedicationConfig';
import { CircularProgress } from '@material-ui/core';
import { primary } from '../Styles/Colours';
export var ClinicalDecisionSupport = function (props) {
    var ref = React.useRef(null);
    var acceptButtonRef = React.useRef(null);
    var declineButtonRef = React.useRef(null);
    var _a = __read(useState(false), 2), showDeleteMedication = _a[0], setShowDeleteMedication = _a[1];
    var _b = __read(useState(false), 2), isLoading = _b[0], setIsLoading = _b[1];
    var throwError = useError();
    var medicationSettings = useMedicationSettings();
    var decisionSupportSettings = medicationSettings.settings.decisionSupportSettings;
    var getPromptType = function (type) {
        if (type == AlertType.Critical)
            return AlertBannerTypes.Error;
        else if (type == AlertType.Warning)
            return AlertBannerTypes.Warn;
        if (type == AlertType.Informational)
            return AlertBannerTypes.Warn;
    };
    var cardContent = function (info) { return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.cardHeading },
            React.createElement("div", { className: styles.cardHeadingText }, info.title)),
        React.createElement("div", { className: styles.cardBody, dangerouslySetInnerHTML: { __html: info.message } }),
        info.allergenReaction != null && React.createElement("div", { className: styles.cardBody, dangerouslySetInnerHTML: { __html: 'Reaction: ' + info.allergenReaction } }))); };
    var Message = function (_a) {
        var cds = _a.cds;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.content },
                React.createElement(AlertBanner, { promptMessage: cardContent(cds), promptType: getPromptType(cds.alertType), verticalSpace: true }))));
    };
    var renderCards = function (type) {
        return props.cdsDetailsList.filter(function (a) { return a.alertType == type; }).map(function (x) {
            return React.createElement(Message, { key: x.title, cds: x });
        });
    };
    var cardsCount = function (type) {
        return props.cdsDetailsList.filter(function (a) { return a.alertType == type; }).length;
    };
    var onAccept = function () {
        setIsLoading(true);
        props.onHandleNextMedication(false);
        if (acceptButtonRef.current) {
            acceptButtonRef.current.blur();
        }
        if (ref.current) {
            ref.current.scrollTop = 1;
        }
    };
    useEffect(function () {
        setIsLoading(props.acceptLoading);
    }, [props.acceptLoading]);
    var onDecline = function () {
        if (declineButtonRef.current) {
            declineButtonRef.current.blur();
        }
        setShowDeleteMedication(false);
        props.setIgnoreFormValidation(true);
        props.onUpdate();
        props.onHandleNextMedication(true);
        if (declineButtonRef.current) {
            declineButtonRef.current.blur();
        }
        if (ref.current) {
            ref.current.scrollTop = 1;
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.body, ref: ref },
            React.createElement("div", { className: styles.container },
                React.createElement("div", { className: styles.innerBody },
                    !props.isCdsFailed &&
                        React.createElement("div", { className: styles.content },
                            React.createElement("label", { className: styles.info },
                                "Please review each alert before clicking ",
                                React.createElement("label", { className: styles.infoBold }, "Accept and continue"),
                                " at the bottom of this window.")),
                    cardsCount(AlertType.Critical) > 0 &&
                        React.createElement(React.Fragment, null,
                            React.createElement("div", { className: styles.content },
                                React.createElement("label", { className: styles.alertHeading },
                                    cardsCount(AlertType.Critical),
                                    " critical ",
                                    singularisePluralise('alert', cardsCount(AlertType.Critical)),
                                    " for ",
                                    props.medicationName)),
                            renderCards(AlertType.Critical)),
                    (cardsCount(AlertType.Warning) > 0 || cardsCount(AlertType.Informational) > 0) &&
                        React.createElement(React.Fragment, null,
                            !props.isCdsFailed && React.createElement("div", { className: styles.content },
                                React.createElement("label", { className: styles.alertHeading },
                                    cardsCount(AlertType.Warning) + cardsCount(AlertType.Informational),
                                    " other ",
                                    singularisePluralise('alert', cardsCount(AlertType.Warning) + cardsCount(AlertType.Informational)),
                                    " for ",
                                    props.medicationName)),
                            renderCards(AlertType.Warning),
                            renderCards(AlertType.Informational)),
                    props.isCdsFailed &&
                        React.createElement("div", { className: styles.content },
                            React.createElement("label", { className: styles.info },
                                "If you want to proceed without viewing any potential alerts please click ",
                                React.createElement("label", { className: styles.infoBold }, "Accept and continue."),
                                React.createElement("br", null),
                                " Alternatively, if you do not wish to proceed please click ",
                                React.createElement("label", { className: styles.infoBold }, props.isReprescribe ? 'Decline and don’t re-prescribe' : 'Decline and don’t prescribe'),
                                "."))),
                React.createElement("hr", null),
                !props.isCdsFailed &&
                    React.createElement("div", { className: styles.content },
                        React.createElement("label", { className: styles.disclaimer }, decisionSupportSettings.decisionSupportWarningDisclaimer)),
                React.createElement("div", { className: styles.buttonContent },
                    React.createElement(Button, { variant: ButtonVariant.redBorder, className: styles.buttonSpace, ref: declineButtonRef, testId: 'cds-medication-decline', onClick: function () { return setShowDeleteMedication(true); } }, props.isReprescribe ? 'Decline and don’t re-prescribe' : 'Decline and don’t prescribe'),
                    !isLoading ?
                        React.createElement(Button, { variant: ButtonVariant.primary, ref: acceptButtonRef, testId: 'cds-medication-accept', onClick: function () {
                                return onAccept();
                            } }, "Accept and continue") :
                        React.createElement(Button, { variant: ButtonVariant.lightGray, mode: ButtonMode.solid, disabled: true, startIcon: React.createElement(CircularProgress, { size: 14, style: { color: primary } }), testId: 'cds-medication-accept-loading' }, "Loading...")))),
        showDeleteMedication && (React.createElement(DeleteMedicationDialog, { medicationName: props.medicationName || '', medicationId: props.medicationId || '', onDelete: function () {
                onDecline();
            }, handleErrorOnDelete: function (err) {
                throwError(err);
                props.onUpdate();
            }, setShowDeleteMedicationDialog: function (show) {
                setShowDeleteMedication(false);
            } }))));
};
